import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findTemplate = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sms/v1/template?`+params,
        method: 'GET'
    })
}

export const findTemplateAll = () => {
    return request({
        url: `${baseUrl}/joins-sms/v1/template/all`,
        method: 'GET'
    })
}

export const addTemplate = (data) => {
    return request({
        url: `${baseUrl}/joins-sms/v1/template`,
        method: 'POST',
        data: data
    })
}

export const editTemplate = (data) => {
    return request({
        url: `${baseUrl}/joins-sms/v1/template`,
        method: 'PUT',
        data: data
    })
}

export const delTemplate = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sms/v1/template/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}